import { render, staticRenderFns } from "./PageCommonFilter.vue?vue&type=template&id=36435ab0&"
import script from "./PageCommonFilter.vue?vue&type=script&lang=js&"
export * from "./PageCommonFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports